export default "__VITE_ASSET__DDv1V0kU__"